import { roboto, robotoBold, robotoLight, robotoMedium } from "../../app/fonts"

export const Fonts = {
  primary: "Inter, 'sans-serif'",
  secondary: "Ogg, 'sans-serif'",
  tertiary: "'helveticaNow', 'sans-serif'",
  defaultLight: `${robotoLight.style.fontFamily}`,
  default: `${roboto.style.fontFamily}`,
  defaultMedium: `${robotoMedium.style.fontFamily}`,
  defaultBold: `${robotoBold.style.fontFamily}`,
}
